import type { ReactNode } from 'react';

// Responsive control container: a bottom sheet in portrait, a right-hand column in landscape (the
// in-cab touchscreen orientation) so wide screen real estate is used well.
export function Panel({ children }: { children: ReactNode }) {
  return (
    <div className="pb-safe pointer-events-auto absolute inset-x-0 bottom-0 max-h-[72vh] overflow-y-auto rounded-t-2xl bg-zinc-900/90 p-4 text-white shadow-2xl backdrop-blur md:rounded-t-3xl md:p-5 landscape:inset-x-auto landscape:bottom-3 landscape:left-3 landscape:max-h-[66vh] landscape:w-[23rem] landscape:rounded-3xl">
      <div className="mx-auto flex max-w-xl flex-col">{children}</div>
    </div>
  );
}
